<template>
  <div id="workbench"
       :class="isDark?'dark':''">
    <div class='top-menus'>
      <div class="active">
        <a-icon type="line-chart"
                style="margin-right: 10px" />数据统计
      </div>
      <div>
        <a-icon type="user"
                style="margin-right: 10px" />作者排名
      </div>
      <div>
        <a-icon type="appstore"
                style="margin-right: 10px" />综合信息
      </div>
      <div class="float-right"
           v-if="!isDark"
           @click="changeDark">
        <img src="https://oss.mrepress.net/static/console/dark.png"
             alt="">
        夜间模式
      </div>
      <div class="float-right"
           v-else
           @click="changeLight">
        <img src="https://oss.mrepress.net/static/console/light.png"
             alt="">
        日间模式
      </div>
    </div>
    <iframe :src="url"
            frameborder="0"></iframe>
  </div>
</template>

<script>
import workbench from './workbench.js'
export default workbench
</script>

<style lang="scss" scoped>
@import "./workbench.scss";
</style>


